import React from 'react'
import {getMUICache, loadStyles } from '../../core/Utils';
import Grid from '@mui/material/Grid';
import { CacheProvider } from '@emotion/react';
import PageNotFoundStyles from './Error.css'


const PageGone = (props) => {
    const cache = getMUICache();

    return(
        <div className='commoncontainer' styles={PageGone}>
          <CacheProvider value={cache}>
          <Grid container p={2} spacing={2}>
            <Grid item md={12} xs={12}>
                <div className='errorwrapper'>
                    <div className='erroeheading'>
                        <h3>410</h3>
                    </div>
                    <div className='errorcontent'>
                        <p>This content has been permanently removed and is no longer available.</p>
                        <p></p>
                    </div>
                </div>
                </Grid>
                </Grid>
          </CacheProvider>
        </div>

    )

}

export default PageGone;